import { render, staticRenderFns } from "./PAlert.vue?vue&type=template&id=30817d1f"
import script from "./PAlert.vue?vue&type=script&lang=js"
export * from "./PAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports